import { paths } from '../../../../links'

export const alertDisplayData = {
  manyPastdueLoans: {
    message: 'PastdueAlert.manyPastdueLoans',
    buttonLabel: 'PastdueAlert.go-to-credit-page',
    onPress: (navigation) => {
      navigation.navigate(paths.Console.Credit._self)
    },
  },
  manyPastdueWithLatefee: {
    message: 'PastdueAlert.manyPastdueWithLatefee',
    buttonLabel: 'PastdueAlert.go-to-credit-page',
    onPress: (navigation) => {
      navigation.navigate(paths.Console.Credit._self)
    },
  },
  singlePastDueLoan: {
    message: 'PastdueAlert.singlePastDueLoan',
    buttonLabel: 'PastdueAlert.make-payment',
    onPress: null,
  },
  singlePastDueLoanWithLateFee: {
    message: 'PastdueAlert.singlePastDueLoanWithLateFee',
    buttonLabel: 'PastdueAlert.pay-loan-now',
    onPress: null,
  },
}
